import { graphql } from '@/gql';

graphql(`
  fragment CallOptionsFragment on CallOptionResponse {
    noCalls
    marketingCalls
    driverArriving
    callRiderPriceChange
    callPartnerCallerAboutPartnerCredits
    scheduledDeliveryPreauthFailedCallIn24Hours
    callRiderDriverCanceled
    callRiderTripCost
    callNewDriverInfo
    callRiderDriverDetails
    scheduledGroceryUnpaidServicesCallIn24Hours
    scheduledDeliveryUnpaidServicesCallIn24Hours
    scheduledGroceryPreauthFailedCallIn24Hours
    scheduledRideUnpaidServicesCallIn24Hours
    scheduledRidePreauthFailedCallIn24Hours
    callWarnNoShowFee
    groceriesMarketingCalls
    ridesMarketingCalls
    gourmetMarketingCalls
    callWarnInProgressDriverCancellation
    isSendUserPhoneNumberInDriverAcceptedTextMessage
    priceConfirm
    callPartnerCallerAboutPartnerRides
    scheduledRideSurgeCall
    scheduledRideCall
    pricePendingRideCall
    cancellationFeeDisputeFailedCall
    sendNeedLoveAutomatedCall
    sendNeedLoveRefundAutomatedCall
    pricePendingRideAfterDateExpiredCall
    scheduledRidePayForAnyUnpaidServicesFailedCall
    scheduledRideReminderDayBeforeCall
    scheduledRideReminderMinutesAfterCreation
    scheduledRideCustomReminderCall
    scheduledGroceryPayForAnyUnpaidServicesFailedCall
    scheduledGroceryBeforeTheDayCall
    scheduledGroceryCustomReminderCall
    scheduledDeliveryPayForAnyUnpaidServicesFailedCall
    scheduledDeliveryReminderCall
    subscriptionChargeSuccessCall
    subscriptionChargeFailedCall
    membershipRenewalReminderCall
    membershipTrialWillEndIn3DaysCall
    weeklyCheckInMarketingCall
    groceryOrderShoppingCall
    groceryOrderShoppingCompleteCall
    groceryOrderInTransitCall
    groceryOrderCanceledCall
    groceryOrderReminderCall
    groceryOrderOutsideReminderCall
    etaDelayCall
    refundDepositDeniedCall
    deliveryArrivalCall
    deliveryAfterOrderCall
    deliveryAfterHoursOrderStatusUpdateCall
  }
`);
